import React, { useState } from 'react';


import { AskTripForm as Form } from './asktrip/AskTripForm';
import { AskTripQuestion as Question } from './asktrip/AskTripQuestion';
import { AskTripQuestions as Questions } from './asktrip/AskTripQuestions';
import { AskTripExplained as Explained } from './asktrip/AskTripExplained';

export const localKeyUserTokens= 'tokens';
export const localKeyInstitutionTokens = 'instution_auth_tokens'; // misspelled, I know...

// common header elements included from other functions below
export function AskTripHeader() {

    const path = window.location.pathname; // we apply an 'active' class to the current page link

    return (
        <div>
            <div className='d-flex pt-3 ps-3'><a className='btn btn-sm text-decoration-underline' href="/Home">Return to Trip</a></div>
            <div className="ask-header d-flex flex-column align-items-center justify-content-between pt-5 pb-1 container">
                <a href="/ask" className='d-flex justify-content-center'>
                    <img width="400" src="/inline-asktrip_logo.svg" alt="AskTrip logo" className="ask-header-logo mb-3" />
                </a>
                <div className="d-flex flex-row flex-wrap justify-content-center gap-2 gap-lg-4">

                    <div className="ask-header-nav d-flex flex-row flex-wrap justify-content-center align-items-center gap-2 gap-lg-0">
                        <a href="/ask" className={path === '/ask' ? 'active' : ''}>Ask a Question</a>
                        
                        <a href="/ask/archive" className={path === '/ask/archive' ? 'active' : ''}>Past Questions</a>
                        <a href="/ask/search" className={path === '/ask/search' ? 'active' : ''}>Search Questions</a>
                        
                    </div>
                    <div className="ask-header-nav d-flex flex-row flex-wrap justify-content-center align-items-center">
                        
                        <a href="/ask/explained" className={path === '/ask/explained' ? 'active' : ''}>'AskTrip' Explained</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

// common fopoter 
export function AskTripFooter() {
    return <div className="ask-footer p-4">
        <div className='container'>
            <div className='row my-5'>
                <div className='col-12 col-lg-6 d-flex align-middle pb-3 pb-md-0'>
                    <img src="/inline-asktrip_logo.svg" alt="AskTrip logo" />
                </div>
                <div className='col-12 col-lg-6 flow'>
                    <h3 className='h2 text-primary bold'>AskTrip is an AI-powered tool that helps clinicians quickly explore high-quality evidence in response to clinical questions. </h3>
                    <p>Drawing on decades of experience and trusted sources such as guidelines and systematic reviews, AskTrip supports access to relevant information in seconds. Simply type your question, and the system presents a clear, referenced summary to inform your thinking — all designed to complement clinical judgement.</p>
                    <a href="/ask/explained" className="btn btn-primary">Find out what AskTrip is all about</a>
                </div>
            </div>
        </div>
    </div>
}

export function AskTripForm() {

    return <div className="ask-container"><AskTripHeader /><Form /><AskTripFooter /></div>
}

export function AskTripQuestion(props) {

    const id= props.match.params.id || ''; // Get the question ID from the URL parameters

    // Extract the question ID from the URL parameters
    const questionId = extractQuestionId(id);

    return <div className="ask-container"><AskTripHeader /><Question questionId={questionId} /><AskTripFooter /></div>

}

export function AskTripExplained() {

    return <div className="ask-container"><AskTripHeader /><Explained /><AskTripFooter /></div>

}

// Page to search for questions - https://www.tripdatabase.com/ask/search?q=some+search+term
export function AskTripSearch() {

    return <div className="ask-container"><AskTripHeader /><Questions filterSearch={true} filterQuality={true} filterTypes={true} /><AskTripFooter /></div>

}

export function AskTripArchive() {

    return <div className="ask-container"><AskTripHeader /><Questions searchEmpty={true} filterAreas={true} filterQuality={true} filterTypes={true} /><AskTripFooter /></div>

}



// Extract the uuid from the slug format "slug-slug-slug-id-id-id-id-id"
export function extractQuestionId(id) {
    const parts = id.split('-');
    while (parts.length>5) { parts.shift(); } // Remove any leading parts if slug is too long
    const questionId=parts.join('-'); // Join the remaining parts back together
    return questionId; // Return the extracted question ID
    
}
